// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var englishTranslation = {
    translations: {
        philippinePassport: "Philippine Passport",
        seamanBook: "Seaman's Book",
        philSysID: "PhilSys ID",
        iBP: "Integrated Bar of the Philippines (IBP)",
        driversLicense: "Driver's License",
        loading: "Loading...",
        loadingDataProvider: "Loading data provider...",
        tallySheetImport: {
            title: "Tally sheet imports",
            subtitle: "Import ES&S or CSV tally sheet files, preview the generated ballot boxes, and approve them before they create tally sheets.",
            createTitle: "Import tally sheets",
            detailTitle: "Tally sheet import",
            empty: "No tally sheet imports yet.",
            emptyBody: "Start by importing an ES&S Enhanced XML or canonical CSV file for this election event.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "Canonical CSV",
            },
            channel: {
                PAPER: "Paper",
                POSTAL: "Postal",
                IN_PERSON: "In person",
            },
            table: {
                created: "Created",
                createdBy: "Created by",
                file: "File",
                format: "Format",
                channel: "Channel",
                status: "Status",
                labels: "Labels",
                annotations: "Annotations",
                actions: "Actions",
            },
            summary: {
                imported: "Imported",
                changed: "Changed",
                new: "New",
                unchanged: "Unchanged",
                conflicted: "Conflicted",
                errors: "Errors",
            },
            status: {
                PENDING_REVIEW: "Pending review",
                APPROVED: "Approved",
                DISAPPROVED: "Disapproved",
                FAILED_VALIDATION: "Failed validation",
                CONFLICTED: "Conflicted",
                NEW: "New",
                CHANGED: "Changed",
                UNCHANGED: "Unchanged",
            },
            fields: {
                format: "Format",
                channel: "Channel",
                supportedFormats: "Supported formats: XML, CSV",
                generatedTallySheet: "Generated tally sheet",
                sourceCandidates: "Source candidate IDs",
                none: "None",
            },
            actions: {
                create: "Import tally sheets",
                review: "Review",
                source: "Source",
                cancel: "Cancel",
                preview: "Preview",
                save: "Save import",
                approve: "Approve",
                disapprove: "Disapprove",
                close: "Close",
                openExisting: "Open existing",
            },
            notifications: {
                selectFile: "Select an import file before previewing it",
                duplicateSource: "This source file hash already appears in a previous tally sheet import.",
                uploadUrlError: "Could not create upload URL",
                uploadError: "Could not upload import file",
                previewEmpty: "Preview response was empty",
                previewError: "Could not preview import",
                importEmpty: "Import response was empty",
                created: "Tally sheet import created",
                createError: "Could not create import",
                reviewEmpty: "Review response was empty",
                conflicted: "Import has stale baseline conflicts",
                approved: "Import approved",
                disapproved: "Import disapproved",
                reviewError: "Could not review import",
                sourceUrlError: "Could not create source download URL",
                sourceDownloadError: "Could not download source file",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} of {{total}}",
                previous: "Previous",
                next: "Next",
            },
        },
        reconciliation: {
            menuButton: "Ext. voters sync",
            categories: {
                VOTED_INTERNET: "Voted via Internet",
                VOTED_OTHER_CHANNEL: "Voted via other channel",
                DISABLED_DELETE_CALL: "Voter disabled",
                DELETION_REVERTED: "Deletion reverted",
                PROFILE_UPDATE: "Profile update",
                VOTER_ADDED: "Voter added",
                REENABLED: "Voter re-enabled",
                VOTED_UNMARKED: "Voter unmarked as voted",
                ROW_FAILURE: "Row failure",
            },
            table: {
                voterId: "Voter ID",
                field: "Field",
                category: "Category",
                currentValue: "Current value",
                newValue: "New value",
                reason: "Reason",
                rowLabel: "Row",
                noDifferences: "No differences found - the systems are in sync.",
            },
            wizard: {
                title: "External reconciliation sync",
                subtitle: "Synchronize the voter list with the external system",
                drop: {
                    description: "Drop the reconciliation file the external system produced - both diffs (external-side and Sequent-side) are calculated automatically and shown in separate tables.",
                    fileFormatLabel: "CSV file",
                    uploading: "Uploading {{fileName}} and calculating both diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Sequence {{sequence}}, generated {{generatedAt}}",
                    rowFailuresWarning: "{{count}} row(s) could not be reconciled safely and are excluded from both diffs - see below for details.",
                    noDifferences: "No differences - the two systems are already in sync.",
                    diffOnlyDifferences: "This is a convergence check for an already applied Sequence. Differences are shown for follow-up, but this round cannot be applied again.",
                    externalDiffTitle: "External diff",
                    sequentDiffTitle: "Sequent diff",
                    downloadExternalPatch: "Download external patch",
                    externalDiffCaption: "Download the patch and deliver it to the external system outside this tool. Once it applies the patch and produces the next reconciliation file, click 'Back' and drop that file in - 'Apply' unlocks once this table is empty.",
                    noExternalDifferences: "No external-side differences.",
                    sequentDiffCaption: "Apply changes directly to Sequent by clicking 'Apply' - no patch file is generated for these.",
                    noSequentDifferences: "No Sequent-side differences.",
                },
                applying: {
                    inProgress: "Applying Sequent-side changes...",
                    rowFailures: "{{count}} row(s) were excluded from this round and need manual follow-up - see below for details.",
                    rowFailuresTruncated: "Showing the first {{shown}} of {{count}} row failures. Resolve the shared cause and retry to see any remaining failures.",
                    success: "All Sequent-side changes applied successfully.",
                },
                actions: {
                    cancel: "Cancel",
                    back: "Back",
                    apply: "Apply",
                    next: "Next",
                    startOver: "Start over",
                    close: "Close",
                },
                confirm: {
                    title: "Confirm reconciliation changes",
                    categoriesNote: "Categories outlined in orange ({{categories}}) touch voted status or disable voters.",
                    applyChanges: "Apply changes",
                    continue: "Continue",
                },
                summary: {
                    votedOtherChannel: "marks {{count}} voter(s) as voted via other channels",
                    disabled: "disables {{count}} voter(s)",
                    reenabled: "re-enables {{count}} voter(s)",
                    votedUnmarked: "unmarks {{count}} voter(s) as voted",
                    profileUpdated: "updates {{count}} profile(s)",
                    voterAdded: "adds {{count}} voter(s)",
                    prefix: "This will apply changes that {{parts}}.",
                    empty: "There are no Sequent-side changes to apply.",
                },
                notifications: {
                    envelopeLoadError: "Failed to load the reconciliation diff - please try again.",
                    generateFailed: "Failed to calculate the reconciliation diff - see the task widget for details.",
                    applyFailed: "Failed to apply the Sequent-side changes - see the task widget for details.",
                    uploadUrlError: "Failed to get an upload URL",
                    generateTaskError: "Failed to start the reconciliation diff task",
                    uploadError: "Failed to upload the reconciliation file",
                    applyTaskError: "Failed to start the apply task",
                    applyError: "Failed to apply the reconciliation changes",
                },
            },
        },
        logsScreen: {
            noPermissions: "You don't have permission to access logs.",
            title: "Logs",
            subtitle: "General logs of the main and IAM databases",
            actions: {
                csv: "Export in CSV",
                pdf: "Export in PDF",
            },
            exportdialog: {
                description: "Please confirm you want to execute this action, it might take a while to execute.",
            },
            column: {
                id: "Id",
                statement_kind: "Statement kind",
                created: "Created",
                statement_timestamp: "Statement Timestamp",
                message: "Message",
                user_id: "User Id",
                username: "Username",
                sender_pk: "Sender Pk",
                log_type: "Log Type",
                event_type: "Event Type",
                description: "Description",
                version: "Version",
            },
            main: {
                title: "Main Database Logs",
            },
            iam: {
                title: "IAM Database Logs",
            },
        },
        tasksScreen: {
            noPermissions: "You don't have permission to access logs.",
            title: "Tasks Execution",
            subtitle: "Information about the executed tasks",
            taskInformation: "Task Information",
            status: "status: {{status}}",
            ok: "Ok",
            column: {
                id: "Index",
                name: "Task name",
                type: "Type",
                execution_status: "Status",
                start_at: "Start time",
                end_at: "End time",
                executed_by_user: "Executer",
                annotations: "Annotations",
                labels: "Labels",
                logs: "Logs",
            },
            tasksExecution: {
                DELETE_TENANT: "Delete tenant",
                PUBLISH_BALLOT: "Publish Ballot",
                EXPORT_ELECTION_EVENT: "Export Election Event",
                CREATE_ELECTION_EVENT: "Create Election Event",
                IMPORT_ELECTION_EVENT: "Import Election Event",
                IMPORT_USERS: "Import Users",
                EDIT_USER: "Edit Voter",
                IMPORT_CANDIDATES: "Import Candidates",
                EXPORT_VOTERS: "Export Voters",
                CREATE_TRANSMISSION_PACKAGE: "Create Transmission Package",
                EXPORT_BALLOT_PUBLICATION: "Export Ballot Publication",
                EXPORT_ACTIVITY_LOGS_REPORT: "Export Activity Logs Report",
                GENERATE_REPORT: "Generate Report",
                GENERATE_TRANSMISSION_REPORT: "Generate Transmission Report",
                EXPORT_TRUSTEES: "Export Trustees",
                EXPORT_APPLICATION: "Export Applications",
                EXPORT_TENANT_CONFIG: "Export Tenant Config",
                IMPORT_TENANT_CONFIG: "Import Tenant Config",
                RENDER_DOCUMENT_PDF: "Render Document PDF",
                CREATE_TENANT: "Create Tenant",
                EXPORT_TEMPLATES: "Export Templates",
                IMPORT_TEMPLATES: "Import Templates",
                DELETE_ELECTION_EVENT: "Delete Election Event",
                DELETE_VOTERS: "Delete Voters",
                PREPARE_PUBLICATION_PREVIEW: "Prepare Publication Preview",
                EXPORT_TALLY_RESULTS_XLSX: "Export Tally Results in XLSX format",
                EXPORT_CERTIFICATE_AUTHORITIES: "Export Certificate Authorities",
                PUBLISH_RESULTS_WEBSITE: "Publish Results Website",
                VOTER_INFORMATION_LETTER: "Voter Information Letter",
            },
            documentAccess: {
                title: "Document access",
                sensitivityNotice: "Sensitive information. Share this password only with the intended recipient.",
                passwordLabel: "Password to open the encrypted PDF",
                showPassword: "Show password",
                copyPassword: "Copy password",
                passwordCopied: "Password copied",
                passwordError: "The PDF password could not be retrieved",
                copyError: "The password could not be copied",
                guidance: "The password is loaded only after you choose Show password. After it loads, a read-only field with copy appears here.",
            },
            widget: {
                taskTitle: "Task: {{title}}",
                viewTask: "View Task",
                downloadDocument: "Download File",
            },
            exportTasksExecution: {
                success: "Export finished successfully",
                error: "Error exporting Tasks Execution",
            },
        },
        areas: {
            common: {
                title: "Areas",
                subTitle: "Area configuration.",
                deleteError: "Error deleting area",
            },
            createAreaSuccess: "Area created",
            updateAreaSuccess: "Area updated",
            createAreaError: "Could not create Area",
            sequent_backend_area_contest: "Contests",
            empty: {
                header: "No Areas yet.",
                action: "Create Area",
            },
            formImputs: {
                allowEarlyVoting: "Allow Early Voting",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Google Calendar Service Account Key",
                gapiEmail: "Google Calendar Authentication Email",
            },
            errors: {
                invalidGapiKey: "Invalid Google Calendar Service Account Key format",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Help Links",
                logoUrl: "Logo URL",
                css: "Custom CSS",
            },
            errors: {
                invalidHelpLinks: "Invalid Help Links format",
            },
        },
        electionTypeScreen: {
            noPermissions: "You don't have permission to access settings.",
            common: {
                title: "Election Type",
                subtitle: "Election type configuration",
                onlineVoting: "Online Voting",
                kioskVoting: "Kiosk Voting",
                telephoneVoting: "Telephone Voting",
                settingTitle: "Settings",
                settingSubtitle: "General Configuration",
                sms: "SMS",
                mail: "Mails",
                createNew: "Create Election Type",
                emptyHeader: "No Election Types yet.",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Election Type",
            },
            edit: {
                title: "Edit Election Type",
            },
            tabs: {
                votingChannels: "VOTING CHANELS",
                electionTypes: "ELECTION TYPES",
                templates: "TEMPLATES",
                languages: "LANGUAGES",
                localization: "LOCALIZATION",
                integrations: "Integrations",
                lookAndFeel: "Look & Feel",
                schedules: "SCHEDULED EVENTS",
                trustees: "TRUSTEES",
                BackupRestore: "Backup / Restore",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "No Trustees yet.",
                createNew: "Create Trustee",
                title: "Trustee",
                subtitle: "Trustee configuration",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Trustee",
            },
            edit: {
                title: "Edit Trustee",
            },
        },
        scheduleScreen: {
            noPermissions: "You don't have permission to access settings.",
            createScheduleSuccess: "Schedule created",
            createScheduleError: "Error creating schedule",
            deleteScheduleSuccess: "Schedule deleted",
            deleteScheduleError: "Error deleting schedule",
            common: {
                title: "Scheduled",
                subtitle: "Schedules configuration",
                createNew: "Create Schedule",
                emptyHeader: "No Schedule yet.",
                emptyBody: "Do you want to create one?",
            },
            create: {
                title: "Create Schedule",
                selectSchedule: "Select one schedule from the predefined list or write a custom one",
            },
            edit: {
                title: "Edit Schedule",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "System lockdown for finalization of Internet voting settings",
                START_PRE_REGISTRATION_OVCS: "Start and end of pre-registration for OVCS",
                END_PRE_REGISTRATION_OVCS: "End of pre-registration for OVCS",
                START_TEST_VOTING_PERIOD: "Start of test voting period",
                END_TEST_VOTING_PERIOD: "End of test voting period",
                START_INTERNET_VOTING_PERIOD: "Start of Internet voting period",
                END_INTERNET_VOTING_PERIOD: "End of Internet voting period",
                LAB_TEST: "Lab test",
                FIELD_TEST: "Field test",
                MOCK_ELECTIONS: "Mock elections",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votes by day",
            votesOverTime: "Votes over time",
            timeResolution: "Time resolution",
            timeRange: "Time range",
            minute: "Minute",
            hour: "Hour",
            day: "Day",
            votersByChannels: "Voters by channel",
            voterLoginURL: "Voter Login URL",
            voterEnrollURL: "Voter Enroll URL",
            voterEnrollKioskURL: "Voter Enroll Kiosk URL",
            ipAddress: {
                emptyState: "No votes yet.",
                title: "IP Addresses",
                ip: "IP",
                country: "Country",
                VoteCount: "Vote Count",
                ElectionName: "Election Name",
                VotersId: "Voters Id",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Election event configuration.",
                showMore: "Show More",
                showLess: "Show Less",
                adminPortal: "Admin Portal",
                allowPublishAfterLockdown: "Only allow election event publishing after lockdown",
                reset: "Reset custom filter",
            },
            edit: {
                general: "General",
                dates: "Dates",
                customUrls: "Custom URLs Prefix",
                votingPeriod: "Voting Period",
                language: "Language",
                allowed: "Voting Channels Allowed",
                materials: "Support Materials",
                ballotDesign: "Ballot Design",
                templates: "Templates",
                reorder: "Reorder elections",
                advancedConfigurations: "Advanced Configurations",
                importCandidates: "Import Candidates",
                custom_filters: "Custom filters",
                voter_authentication: "Voter Authentication",
                realm_attributes: "Keycloak realm attributes",
                realm_attributes_load_error: "Error loading Keycloak realm attributes",
                realm_attributes_update_error: "Error updating Keycloak realm attributes",
                realm_attributes_not_loaded: "Keycloak realm attributes have not loaded, changes were not saved",
                password_policy: "Password Policy",
                password_policy_load_error: "Error loading Keycloak password policy",
                password_policy_update_error: "Error updating Keycloak password policy",
                password_policy_not_loaded: "Keycloak password policy has not loaded, changes were not saved",
            },
            customUrls: {
                login: "Login",
                enrollment: "Enrollment",
            },
            localization: {
                emptyHeader: "No languages were set for the event",
                selectLanguage: "Select Language",
                notify: {
                    success: "Localization updated Successfully",
                    error: "Localization update failed",
                    duplicateKey: "An override with this key and portal scope already exists.",
                    invalidDateTimeFormat: "Invalid date/time format. Use tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localization",
                    subTitle: "Localization configuration",
                },
                labels: {
                    key: "Key",
                    scope: "Portal scope",
                    value: "Value",
                },
                scopes: {
                    legacy: "Legacy ({{portal}})",
                    global: "Global",
                    votingPortal: "Voting portal",
                    ballotVerifier: "Ballot verifier",
                    resultsPortal: "Results portal",
                    adminPortal: "Admin portal",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Minimum length",
                    maximumLength: "Maximum length",
                    includeUppercase: "Include uppercase letters",
                    includeLowercase: "Include lowercase letters",
                    includeDigits: "Include digits",
                    includeSpecialCharacters: "Include special characters",
                    help: {
                        minimumLength: "The minimum number of characters required for the password.",
                        maximumLength: "The maximum number of characters allowed for the password.",
                        includeUppercase: "Require at least one uppercase character in the password.",
                        includeLowercase: "Require at least one lowercase character in the password.",
                        includeDigits: "Require at least one digit in the password.",
                        includeSpecialCharacters: "Require at least one special character in the password string.",
                    },
                    notConfigured: "No password policy is configured. Saving will apply the defaults below.",
                    errors: {
                        lengthRange: "Password lengths must be whole numbers between 1 and 256.",
                        minimumExceedsMaximum: "Minimum length cannot exceed maximum length.",
                        characterClassRequired: "Select at least one character class for the password.",
                    },
                },
                name: "Name",
                alias: "Alias",
                description: "Description",
                startDateTime: "Start Date and Time",
                endDateTime: "End Date and Time",
                language: "Language",
                votingChannels: "Voting Channels",
                materialActivated: "Support Materials Activated",
                supportMaterialsPolicy: {
                    label: "Support Materials Policy",
                    helperText: "Mandatory for Voting requires voters to open each Support Material and acknowledge that they have read them before they can vote.",
                    options: {
                        off: "Off",
                        optional: "Optional",
                        mandatory_for_voting: "Mandatory for Voting",
                    },
                },
                materialTitle: "Title",
                materialSubTitle: "Subtitle",
                logoUrl: "Logo URL",
                userVerification: "You can introduce a custom template that will be used to manually verify the voters",
                redirectFinishUrl: "Redirect Finish URL",
                kioskRedirectFinishUrl: "Kiosk Redirect Finish URL",
                css: "Custom CSS",
                skipElectionList: "Skip Election List Screen",
                showUserProfile: "Show User Profile",
                showCastVoteLogs: {
                    policyLabel: "Show Cast Vote Logs Tab",
                    options: {
                        "show-logs-tab": "Show Cast Vote Logs Tab",
                        "hide-logs-tab": "Hide Cast Vote Logs Tab",
                    },
                },
                lockdownState: {
                    policyLabel: "Lockdown Status",
                    options: {
                        "locked-down": "Locked Down",
                        "not-locked-down": "Not Locked Down",
                    },
                },
                decodedBallots: {
                    policyLabel: "Include decoded ballots to results database",
                    options: {
                        "included": "Include",
                        "not-included": "Don't include",
                    },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Single Contest",
                        "multiple-contests": "Multiple Contests",
                    },
                    policyLabel: "Contest encryption policy",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Voting Portal date & time format",
                    helperText: 'Applies event-wide. To override per language, add the key "votingPortalDateTimeFormat" in the Localization tab using tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm). See the docs for details.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO Local (yyyy-MM-dd HH:mm)",
                        "us-12h": "US 12h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (medium date, short time)",
                        "date-only": "Date Only (no time)",
                        "custom": "Custom format",
                    },
                    customFormat: {
                        label: "Custom date & time format",
                        helperText: "Use tokens yyyy, MM, dd, HH, mm, ss (e.g. dd/MM/yyyy HH:mm). Any other characters are shown literally.",
                        invalid: "Invalid format. Use at least one of the tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "No Countdown",
                    COUNTDOWN: "Countdown",
                    COUNTDOWN_WITH_ALERT: "Countdown with alert",
                    sectionTitle: "Voting Portal",
                    policyLabel: "Voting Portal Countdown policy",
                    coundownSecondsLabel: "time in seconds before expiration to show countdown",
                    alertSecondsLabel: "time in seconds before expiration to show Logout alert",
                },
                voterSigningPolicy: {
                    "policyLabel": "Voter Signing Policy",
                    "no-signature": "No signature",
                    "with-signature": "With signature",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Voter Digital Certificate Policy",
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
                enrollment: {
                    policyLabel: "Enrollment",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Keys/Tally Ceremonies Policy",
                    options: {
                        "automated-ceremonies": "Allow Automatic Ceremonies",
                        "manual-ceremonies": "Manual Ceremonies",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Automatic Recount After Import Approval",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Weighted Voting Policy",
                    options: {
                        "areas-weighted-voting": "Weighted Voting for Areas",
                        "disabled-weighted-voting": "Disabled Weighted Voting",
                        "voters-weighted-voting": "Weighted Voting for Voters",
                    },
                    noDelegated: "Weighted Voting for Voters cannot be combined with Delegated Voting",
                    noDecodedBallots: "Weighted Voting for Voters cannot be combined with including decoded ballots in the results",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Delegated Voting Policy",
                    options: {
                        enabled: "Enabled",
                        disabled: "Disabled",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Language Detection Policy",
                    options: {
                        "browser-detect": "Browser Detect",
                        "force-default": "Force Default",
                    },
                },
            },
            error: {
                endDate: "End date must be after start date",
                startDate: "Start date must be in the future",
                noResult: "No Election Event yet",
                endDateInvalid: "End date must be in the future",
            },
            voters: {
                title: "Voters",
            },
            createElectionEventSuccess: "Election Event created",
            createElectionEventError: "Error creating election event",
            ivr: {
                tabs: {
                    config: "Configuration",
                    blacklist: "Blocklist",
                    prompts: "Prompts",
                    emulator: "Emulator",
                },
                common: {
                    saveSuccess: "Saved successfully",
                    saveError: "Failed to save",
                    deleteSuccess: "Deleted successfully",
                    deleteError: "Failed to delete",
                },
                config: {
                    configuredPhone: "Configured phone number",
                    infoMsg: "Configure the IVR flow and its properties below. For more details, please contact Sequent.",
                },
                prompts: {
                    emptyMsg: "No prompts created yet",
                    infoMsg: "Configure the prompts used by the IVR. Announcement prompts are required, and system prompts can be overridden for desired languages. SSML is supported, including for mixing languages.",
                    editorTitle: "Prompt",
                    editorSubtitle: "Prompt configuration",
                },
                blacklist: {
                    columns: {
                        phone: "Phone number",
                        reason: "Reason",
                        createdAt: "Created at",
                        createdBy: "Created by",
                        createdBefore: "Created before",
                        createdAfter: "Created after",
                    },
                    emptyMsg: "There are no entries in the blocklist",
                    infoMsg: "Configure the blocklist for the IVR. Calls from these numbers will be disconnected automatically by the system.",
                    noFilterMatch: "No entries match the given filters",
                    phoneRequired: "Phone number is required",
                },
                emulator: {
                    infoMsg: "Select an area and desired elections to experience the IVR session.",
                    apiStatus: {
                        unavailable: "The emulator system is not available in your environment",
                        loading: "Loading the emulator system",
                        error: "Error loading the emulator system",
                    },
                    hints: {
                        title: "Hints",
                        publishRequired: "Any changes made to elections, contests or candidates must be published first to be available. Only the latest published ballot styles for the matching area will be used in the emulator.",
                        eventChangesImmediate: "Changes made to the election event, such as IVR configuration or prompt overrides, are available immediately upon emulator session restart.",
                        credentials: 'The valid voter id and pin are "123" and "123".',
                    },
                    sendDtmf: "Send DTMF input",
                    sendTimeout: "Send timeout",
                    disconnected: "Disconnected",
                    startSession: "Start new session",
                    endSession: "End the session",
                    noStylesFound: "No published ballot styles found matching your selections",
                    inputPlaceholder: "Enter your input (max digits={{maxDigits}}, valid inputs={{validInputs}}, timeout={{timeout}}s)",
                    blacklistCaller: "Blocklist the caller",
                    elections: "Elections",
                    area: "Area",
                },
            },
            stats: {
                elegibleVoters: "Eligible Voters",
                voters: "Actual Voters",
                elections: "Elections",
                contests: "Contests",
                areas: "Areas",
                sentEmails: "Emails sent",
                sentSMS: "SMS sent",
                calendar: {
                    title: "Calendar",
                    scheduled: "Scheduled",
                },
            },
            keys: {
                createNew: "Create Keys Ceremony",
                emptyHeader: "No Keys Ceremony yet.",
                statusLabel: "Status",
                waitingKeys: "Waiting for Keys Generation..",
                started: "Started at",
                actions: {
                    participate: "Participate in Keys Ceremony",
                    view: "View Keys Ceremony",
                },
                breadCrumbs: {
                    configure: "Configure",
                    ceremony: "Ceremony",
                    created: "Finished",
                    start: "Start",
                    status: "Status",
                    download: "Download",
                    check: "Check",
                    success: "Finished",
                },
                notify: {
                    participateNow: "You have been invited to participate in a Keys ceremony. Please <1>click on the ceremony's Key Action</1> to participate.",
                },
            },
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Data",
                ivr: "IVR",
                localization: "Localization",
                voters: "Voters",
                areas: "Areas",
                keys: "Keys",
                tally: "Tally",
                tallySheetImports: "Tally sheet imports",
                publish: "Publish",
                logs: "Logs",
                tasks: "Tasks",
                events: "Scheduled Events",
                notifications: "Notifications",
                reports: "Reports",
                approvals: "Approvals",
                cas: "Certificates",
            },
            tally: {
                emptyHeader: "No Tally yet.",
                title: "Election Event Tally",
                elections: "Elections",
                electionNumber: "Number Elections",
                trustees: "Trustees",
                permissionLabels: "Permission Labels",
                status: "Status",
                tallyType: {
                    label: "Tally Type",
                    ELECTORAL_RESULTS: "Electoral Results",
                    INITIALIZATION_REPORT: "Initialization Results",
                },
                create: {
                    title: "Create Tally",
                    subtitle: "Create a new Tally for this Election Event",
                    createTallyButton: "Start Tally Ceremony",
                    createInitializationReportButton: "Generate Initialization Report",
                    error: {
                        create: "Error creating Tally",
                    },
                    success: "Tally created",
                },
                logs: {
                    noLogs: "No logs available",
                },
                notify: {
                    noKeysTally: "The Tally Ceremony cannot start until the Keys Ceremony has been successfully completed.",
                    noPublication: "The Tally Ceremony cannot start until you create one publication in the Publish tab.",
                    participateNow: "You have been invited to participate in a Tally ceremony. Please <1>click on the ceremony's Key Action</1> to participate.",
                    startDisabled: "You cannot continue the ceremony because no elections are selected or the elections are not published.",
                    ceremonyDisabled: "You cannot continue the ceremony because the tally session is not connected or the start of the ceremony is not allowed.",
                },
            },
            importAreas: {
                title: "Import Areas",
                subtitle: "Import areas data",
                areaParagraph: "Import areas using a spreadsheet file in Comma Separated Values (CSV) format.",
                importSuccess: "Areas Imported Successfully",
                importError: "Error importing Areas",
                upsert: "Upsert Areas",
            },
            import: {
                eetitle: "Import Election Event",
                eesubtitle: "Import election event data",
                title: "Import Voters",
                subtitle: "Import voters data",
                voters: "Voters",
                votersParagraph: "Import voters using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
                electionEventParagraph: "Import Election Events using a JSON file.",
                elections: "Elections",
                areas: "Areas",
                sha: "Integrity Check (SHA-256)",
                cancel: "Cancel",
                import: "Import",
                fileUploadSuccess: "File uploaded to server - but not imported yet",
                fileUploadError: "Error uploading file",
                importVotersSuccess: "Voters Import Scheduled Successfully",
                importVotersError: "Error importing Voters",
                importElectionEventSuccess: "Election event imported Successfully",
                importElectionEventError: "Error importing election event",
                shaDialog: {
                    ok: "Yes, Import without Integrity Check",
                    cancel: "Go Back",
                    title: "Import Without Integrity Check?",
                    description: "You didn't enter the Integrity Check (SHA-256) field. Please confirm  that you are importing the correct file and you want to import it.",
                },
                passwordDialog: {
                    title: "Decryption Password",
                    description: "Enter the password to decrypt the file",
                    label: "Password",
                    copyPassword: "Copy Password",
                    ok: "Ok",
                },
            },
            export: {
                title: "Export Election Event",
                subtitle: "Export can be a long operation. Are you sure you want to export records?",
                encryptWithPassword: "Encrypt with Password",
                passwordForcedNote: "The archive will be password protected anyway: reports, applications and bulletin-board data are always encrypted. Tick the box to also include decrypted secret voter fields.",
                includeVoters: "Include Voters",
                activityLogs: "Activity Logs",
                bulletinBoard: "Bulletin Board",
                publications: "Publications",
                s3Files: "S3 Files",
                scheduledEvents: "Scheduled Events",
                exportSuccess: "Election Event exported successfully",
                exportError: "Error exporting Election Event",
                passwordTitle: "Password",
                passwordDescription: "Password to decrypt the file:",
                copiedSuccess: "Password copied to clipboard",
                copiedError: "Error copying password",
                reports: "Reports",
                applications: "Applications",
                tally: "Tally",
                certificates: "Certificates",
            },
            taskNotification: "{{action}} has started. You can see its status at Tasks Execution table.",
        },
        electionScreen: {
            common: {
                title: "Election",
                subtitle: "Election configuration.",
                fileLoaded: "File loaded",
                noPermission: "You don't have permission to access this election.",
            },
            edit: {
                general: "General",
                dates: "Dates",
                votingPeriod: "Voting Period",
                language: "Language",
                allowed: "Voting Channels Allowed",
                default: "Default",
                defaultLang: "Default language",
                receipts: "Receipts",
                image: "Image",
                advanced: "Advanced Configuration",
                numAllowedVotes: "Number of allowed votes",
                reorder: "Reorder contests",
                castVoteConfirm: "Cast Vote Confirmation Modal",
                gracePeriodPolicy: "Grace Period",
                allowTallyPolicy: "Allow Tally",
                permissionLabel: "Permission Label",
                custom_filters: "Custom filters",
            },
            field: {
                name: "Name",
                language: "Language",
                votingChannels: "Voting Channels",
                startDateTime: "Start Date and Time",
                endDateTime: "End Date and Time",
                startDateTimeWithTimezone: "Start Date and Time ({{timezone}})",
                endDateTimeWithTimezone: "End Date and Time ({{timezone}})",
                scheduledOpening: "Scheduled Opening",
                scheduledClosing: "Scheduled Closing",
                alias: "Alias",
                description: "Description",
                securityConfirmationHtml: "Security Confirmation Html",
                ivrPrompt: "IVR prompt",
                externalId: "External ID",
            },
            securityConfirmationPolicy: {
                label: "Security Confirmation Checkbox Policy",
                none: "None",
                mandatory: "Mandatory",
            },
            error: {
                fileError: "Error uploading file",
                fileLoaded: "File loaded",
                endDate: "End date must be after start date",
                startDate: "Start date must be in the future",
                endDateInvalid: "End date must be in the future",
            },
            createElectionEventSuccess: "Election Event created",
            createElectionEventError: "Error creating election event",
            tabs: {
                dashboard: "Dashboard",
                monitoring: "Monitoring",
                data: "Data",
                voters: "Voters",
                publish: "Publish",
                logs: "Logs",
                approvals: "Approvals",
                tallySheets: "Tally Sheets",
            },
            gracePeriodPolicy: {
                "label": "Grace Period Policy",
                "no-grace-period": "No grace period",
                "grace-period-without-alert": "Grace period without alert",
                "gracePeriodSecs": "Grace period in seconds",
            },
            allowTallyPolicy: {
                "allowed": "Allowed",
                "disallowed": "Disallowed",
                "requires-voting-period-end": "Requires Voting Period End",
            },
            initializeReportPolicy: {
                "label": "Initialize Report Policy",
                "not-required": "Not Required",
                "required": "Required",
            },
            castVoteGoldLevelPolicy: {
                label: "Gold level Authentication Policy",
                options: {
                    "gold-level": "Gold level Authentication",
                    "no-gold-level": "No Gold level Authentication",
                },
            },
            startScreenTitlePolicy: {
                label: "Start Screen Title Policy",
                options: {
                    "election": "Election title",
                    "election-event": "Election event title",
                },
            },
            consolidatedReportPolicy: {
                label: "Consolidated Report Policy",
                options: {
                    "generate": "Generate",
                    "do-not-generate": "Do Not Generate",
                },
            },
            declineToVotePolicy: {
                label: "Decline to Vote Policy",
                options: {
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
            },
            blankBallotsPolicy: {
                label: "Blank Ballots Policy",
                options: {
                    enabled: "Enabled",
                    disabled: "Disabled",
                },
            },
            votingScreenBackPolicy: {
                label: "Voting Screen Back Button Policy",
                options: {
                    "election-selection-screen": "Go to the election selection screen",
                    "start-screen": "Go to the election start screen",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Tenants",
            },
            new: {
                subtitle: "Create new tenant",
            },
            createSuccess: "Tenant created",
            createError: "Error creating tenant",
        },
        usersAndRolesScreen: {
            noPermissions: "You don't have permission to access users or roles.",
            common: {
                title: "Users and Roles",
                subtitle: "General configuration",
                mobileNumber: "Mobile",
            },
            editPassword: {
                label: "Change password",
                temporatyLabel: "Temporary",
                temporatyInfo: "If enabled, the user must change the password on next login",
                passwordPolicyViolation: "The password does not meet the Password Policy for this election event. Review the policy under Election Event Data and enter a compliant password.",
                passwordPolicyRules: {
                    minimumLength: "The password minimum length is {{count}}.",
                    maximumLength: "The password maximum length is {{count}}.",
                    uppercase: "Required uppercase characters: {{count}}.",
                    lowercase: "Required lowercase characters: {{count}}.",
                    digits: "Required digits: {{count}}.",
                    specialCharacters: "Required special characters: {{count}}.",
                },
            },
            users: {
                title: "Users",
                subtitle: "View and edit user data",
                review: {
                    title: "Review changes",
                    subtitle: "Confirm these updates before submitting.",
                    confirm: "Confirm changes",
                    noChanges: "No changes to review",
                    field: "Field",
                    currentValue: "Current value",
                    newValue: "New value",
                },
                edit: {
                    title: "User Data",
                    subtitle: "View and edit user",
                },
                create: {
                    title: "User",
                    subtitle: "Create user",
                },
                fields: {
                    "has_voted": "Voted",
                    "support_materials_viewed": "Support Materials Viewed",
                    "vote-weight": "Vote Weight",
                    "voted-channel": "Voted Channel",
                    "disable-comment": "Disable Comment",
                    "username": "Username",
                    "first_name": "First Name",
                    "last_name": "Last Name",
                    "email": "Email",
                    "enabled": "Enabled",
                    "emailVerified": "Email Verified",
                    "groups": "Groups",
                    "attributes": "Attributes",
                    "area": "Area",
                    "password": "Password",
                    "repeatPassword": "Repeat Password",
                    "savePassword": "Save Password",
                    "passwordMismatch": "Passwords must match",
                    "passwordLengthValidate": "Password must be at least 8 characters long",
                    "passwordUppercaseValidate": "Password must contain at least one uppercase letter",
                    "passwordLowercaseValidate": "Password must contain at least one lowercase letter",
                    "passwordDigitValidate": "Password must contain at least one digit",
                    "passwordSpecialCharValidate": "Password must contain at least one special character",
                    "trustee": "Act as Trustee",
                    "permissionLabel": "Permission Label",
                    "authorized-election-ids": "Elections",
                },
                delete: {
                    body: "Are you sure you want to delete this user?",
                    bulkBody: "Are you sure you want to delete the selected users?",
                    bulkBodySelected: "Delete the {{count}} selected users? This cannot be undone.",
                    bulkBodyChoose: "{{count}} users are selected. You can instead delete every user matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error exporting users",
                    deleteError: "Error deleting user",
                    deleteSuccess: "User deleted",
                    multipleDeleteSuccess: "Users deleted",
                },
            },
            voters: {
                title: "Voters",
                subtitle: "View and edit voter data",
                secretAttribute: {
                    storedPlaceholder: "Stored encrypted value",
                    reveal: "Reveal",
                    hide: "Hide",
                    revealError: "The encrypted voter field could not be revealed",
                    includeInExport: "Include decrypted secret voter fields",
                    exportWarning: "Sensitive export: the downloaded CSV will contain these fields in plaintext.",
                    clear: "Clear",
                    add: "Add value",
                    remove: "Remove value",
                },
                review: {
                    title: "Review changes",
                    subtitle: "Confirm these updates before submitting.",
                    confirm: "Confirm changes",
                    noChanges: "No changes to review",
                    field: "Field",
                    currentValue: "Current value",
                    newValue: "New value",
                },
                logs: {
                    label: "User's Logs",
                },
                create: {
                    title: "Voter",
                    subtitle: "Create Voter",
                },
                manualVerification: {
                    label: "Manually Verify",
                    verify: "Manually Verify this voter",
                    body: "Manually Verify this voter. You will obtain a PDF with a QR Code link that allows the voter to login skipping online KYC.",
                    noEmailOrPhone: "This voter can not be manually verified because they do not have an email address or phone number attributed to them.",
                },
                voterInformationLetter: {
                    label: "Voter Information Letter",
                    generate: "Generate",
                    confirmation: "Generate a Voter Information Letter for this voter? A new password will be assigned and included in an encrypted PDF.",
                    generationStarted: "Voter Information Letter generation started",
                    generationError: "The Voter Information Letter could not be generated",
                    policyNotConfigured: "Password Policy is not configured. Set it under Election Event Data before generating a letter.",
                    policyMinimumLengthMissing: "Password Policy must include a minimum length before generating a letter.",
                    policyCharacterClassMissing: "Password Policy must include at least one character class before generating a letter.",
                },
                emptyHeader: "No voters yet.",
                askCreate: "Do you want to create one?",
                errors: {
                    editError: "Error editing voter",
                    editErrorReason: "Error editing voter: {{reason}}",
                    editSuccess: "Voter edited",
                    createError: "Error creating voter",
                    createErrorReason: "Error creating voter: {{reason}}",
                    createSuccess: "Voter created",
                    attribute: {
                        invalidNamed: '"{{field}}" was refused: {{constraint}}',
                        fieldsToCorrect: "Some fields need correcting before saving",
                        hintBetween: "Between {{min}} and {{max}} characters",
                        hintMin: "At least {{min}} characters",
                        hintMax: "At most {{max}} characters",
                        andMore: "and {{count}} more",
                        invalidLength: '"{{field}}" must be between {{min}} and {{max}} characters',
                        tooShort: '"{{field}}" must be at least {{min}} characters',
                        tooLong: '"{{field}}" must be at most {{max}} characters',
                        required: '"{{field}}" is required',
                        invalidEmail: '"{{field}}" must be a valid email address',
                        invalidFormat: '"{{field}}" does not have the expected format',
                        invalid: '"{{field}}" has an invalid value',
                    },
                    createPasswordError: "Voter created, but their password could not be set",
                    createPasswordErrorReason: "Voter created, but their password could not be set: {{reason}}",
                },
                delete: {
                    body: "Are you sure you want to delete this voter?",
                    bulkBody: "Are you sure you want to delete the selected voters?",
                    bulkBodySelected: "Delete the {{count}} selected voters? This cannot be undone.",
                    bulkBodyChoose: "{{count}} voters are selected. You can instead delete every voter matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error exporting voters",
                    deleteError: "Error deleting voter",
                    deleteSuccess: "Voter deleted",
                    multipleDeleteSuccess: "Voters deleted",
                    manualVerificationError: "Error manually verifying the voter",
                    manualVerificationSuccess: "Sucessfully verified manually the voter, downloading PDF..",
                },
            },
            roles: {
                title: "Roles",
                edit: {
                    title: "Role Data",
                    subtitle: "View and edit role",
                },
                create: {
                    title: "Role",
                    subtitle: "Create role",
                },
                errors: {
                    createError: "Error creating role",
                    createSuccess: "Role created",
                },
                fields: {
                    name: "Name",
                },
                delete: {
                    body: "Are you sure you want to delete this role?",
                },
                notifications: {
                    deleteError: "Error deleting role",
                    deleteSuccess: "Role deleted",
                    permissionEditError: "Error editing permission",
                    permissionEditSuccess: "Permission edited",
                },
            },
            permissions: {
                "admin-user": "Admin User",
                "admin-dashboard-view": "Admin Dashboard View",
                "application-export": "Application Export",
                "application-import": "Application Import",
                "tenant-create": "Create Tenant",
                "tenant-read": "Read Tenant",
                "tenant-write": "Edit Tenant",
                "tenant-delete": "Delete Tenant",
                "election-event-create": "Create Election Event",
                "election-event-read": "Read Election Event",
                "election-event-write": "Edit Election Event",
                "keycloak-realm-attributes-read": "Read Keycloak realm attributes",
                "keycloak-realm-attributes-write": "Edit Keycloak realm attributes",
                "election-event-delete": "Delete Election Event",
                "voter-create": "Create Voter",
                "voter-read": "Read Voter",
                "voter-write": "Edit Voter",
                "voter-secret-attribute-read": "Reveal Secret Voter Fields",
                "voter-secret-attribute-write": "Edit Secret Voter Fields",
                "user-create": "Create User",
                "user-read": "Read User",
                "user-write": "Edit User",
                "user-permission-create": "Create User Permission",
                "user-permission-read": "Read User Permission",
                "user-permission-write": "Edit User Permission",
                "role-create": "Create Role",
                "role-read": "Read Role",
                "role-write": "Edit Role",
                "role-assign": "Assign Role",
                "communication-template-create": "Create Communication Template",
                "communication-template-read": "Read Communication Template",
                "communication-template-write": "Edit Communication Template",
                "notification-read": "Read Notification",
                "notification-write": "Edit Notification",
                "notification-send": "Send Notification",
                "area-read": "Read Area",
                "area-write": "Edit Area",
                "election-state-write": "Edit Election State",
                "election-type-create": "Create Election Type",
                "election-type-read": "Read Election Type",
                "election-type-write": "Edit Election Type",
                "voting-channel-read": "Read Voting Channel",
                "voting-channel-write": "Edit Voting Channel",
                "trustee-create": "Create Trustee",
                "trustee-read": "Read Trustee",
                "trustee-write": "Edit Trustee",
                "tally-read": "Read Tally",
                "tally-start": "Start Tally",
                "tally-write": "Edit Tally",
                "tally-results-read": "Read Tally Results",
                "publish-read": "Read Publish",
                "publish-write": "Edit Publish",
                "publish-results-read": "Read Results Publication",
                "publish-results-write": "Edit Results Publication",
                "logs-read": "Read Logs",
                "tasks-read": "Read Tasks Execution",
                "keys-read": "Read Keys",
                "document-upload": "Upload Documents",
                "document-download": "Download Documents",
                "document-password-read": "Read Document Passwords",
                "tally-sheet-create": "Create Tally Sheet",
                "tally-sheet-import-create": "Create Tally Sheet Import",
                "tally-sheet-import-review": "Review Tally Sheet Import",
                "tally-sheet-import-view": "View Tally Sheet Import",
                "tally-recount-execute": "Execute Tally Recount",
                "trustee-ceremony": "Trustee Ceremony",
                "tally-sheet-review": "Review Tally Sheet",
                "tally-sheet-view": "View Tally Sheet",
                "admin-ceremony": "Admin Ceremony",
                "tally-sheet-delete": "Delete Tally Sheet",
                "cast-vote-read": "Read Cast Votes",
                "document-read": "Read Documents",
                "document-write": "Edit Documents",
                "support-material-read": "Read Support Materials",
                "support-material-write": "Edit Support Materials",
                "miru-create": "Miru Create",
                "miru-download": "Miru Download",
                "miru-send": "Miru Send",
                "miru-sign": "Miru Sign",
                "contest-write": "Edit Contest",
                "contest-read": "Read Contest",
                "candidate-write": "Edit Candidate",
                "candidate-read": "Read Candidate",
                "permission-label-write": "Edit Permission Label",
                "scheduled-event-write": "Edit Scheduled Events",
                "contest-create": "Create Contest",
                "contest-delete": "Delete Contest",
                "candidate-create": "Create Candidate",
                "candidate-delete": "Delete Candidate",
                "election-create": "Create Election",
                "election-read": "Read Election",
                "election-write": "Edit Election",
                "election-delete": "Delete Election",
                "election-event-archive": "Archive Election Event",
                "election-data-tab": "View Election Data",
                "election-event-areas-tab": "View Election Event Areas",
                "election-event-data-tab": "View Election Event Data",
                "election-event-keys-tab": "View Election Event Keys",
                "election-event-logs-tab": "View Election Event Logs",
                "election-event-publish-tab": "View Election Event Publish",
                "election-event-reports-tab": "View Election Event Reports",
                "election-event-scheduled-tab": "View Election Event Scheduled",
                "election-event-tally-tab": "View Election Event Tally",
                "election-event-tasks-tab": "View Election Event Tasks",
                "election-event-voters-tab": "View Election Event Voters",
                "election-publish-tab": "View Election Publish",
                "election-voters-tab": "View Election Voters",
                "report-write": "Edit Reports",
                "report-read": "Read Reports",
                "users-menu": "View users and roles",
                "settings-menu": "View settings",
                "templates-menu": "View templates",
                "settings-election-types-tab": "View election types settings",
                "settings-voting-channels-tab": "View voting channels settings",
                "settings-templates-tab": "View templates settings",
                "settings-languages-tab": "View languages settings",
                "settings-localization-tab": "View localization settings",
                "settings-look-feel-tab": "View look and feel settings",
                "settings-trustees-tab": "View truestees settings",
                "settings-countries-tab": "View countries settings",
                "voter-import": "Import Voter",
                "ee-voters-columns": "View Election Event Voters Columns",
                "voter-manually-verify": "Manually Verify Voter",
                "ee-voters-logs": "View Election Event Voters Logs",
                "voter-export": "Export Voter",
                "ee-voters-filters": "View Election Event Voters Filters",
                "voter-delete": "Delete Voter",
                "voter-change-password": "Change Voter Password",
                "voter-information-letter": "Generate Voter Information Letter",
                "election-event-localization-selector": "Election Event Localization Selector",
                "localization-create": "Create Localization",
                "localization-read": "Read Localization",
                "localization-write": "Edit Localization",
                "localization-delete": "Delete Localization",
                "area-create": "Create Area",
                "area-delete": "Delete Area",
                "area-export": "Export Area",
                "area-import": "Import Area",
                "area-upsert": "Upsert Area",
                "election-event-areas-columns": "Election Event Areas Columns",
                "election-event-areas-filters": "Election Event Areas Filters",
                "election-event-tasks-back-button": "Back to Election Event Tasks",
                "election-event-tasks-columns": "Election Event Tasks Columns",
                "election-event-tasks-filters": "Election Event Tasks Filters",
                "task-export": "Export Tasks",
                "application-read": "Read Application",
                "application-write": "Edit Application",
                "logs-export": "Export Logs",
                "election-event-logs-columns": "Election Event Logs Columns",
                "election-events-logs-filters": "Election Event Logs Filters",
                "election-event-scheduled-event-columns": "Election Event Scheduled Event Columns",
                "scheduled-event-create": "Create Scheduled Event",
                "scheduled-event-delete": "Delete Scheduled Event",
                "election-event-reports-columns": "Election Event Reports Columns",
                "report-create": "Create Report",
                "report-delete": "Delete Report",
                "report-generate": "Generate Report",
                "report-preview": "Preview Report",
                "monitor-authenticated-voters": "Monitoring Authenticated Voters",
                "monitor-all-approve-disapprove-voters": "Read Monitoring Approve Disapprove Voters",
                "monitor-automatic-approve-disapprove-voters": "Read Monitoring Automatic Approve Disapprove Voters",
                "monitor-manually-approve-disapprove-voters": "Read Monitoring Manually Approve Disapprove Voters",
                "monitor-enrolled-overseas-voters": "Read Monitoring Enrolled Overseas Voters",
                "monitor-posts-already-closed-voting": "Read Monitoring Posts Already Closed Voting",
                "monitor-posts-already-generated-election-results": "Read Monitoring Posts Already Generated Election Results",
                "monitor-posts-already-opened-voting": "Read Monitoring Posts Already Opened Voting",
                "monitor-posts-already-started-counting-votes": "Read Monitoring Posts Already Started Counting Votes",
                "monitor-posts-initialized-the-system": "Read Monitoring Posts Initialized The System",
                "monitor-posts-started-voting": "Read Monitoring Posts Started Voting",
                "monitor-posts-transmitted-results": "Read Monitoring Posts Transmitted Results",
                "monitor-voters-voted-test-election": "Read Monitoring Voters Voted Test Election",
                "monitor-voters-who-voted": "Read Monitoring Voters Who Voted",
                "election-event-publish-preview": "Preview Election Event Publish",
                "election-event-publish-back-button": "Back to Election Event Publish",
                "election-event-publish-columns": "Election Event Publish Columns",
                "election-event-publish-filters": "Election Event Publish Filters",
                "publish-create": "Create Publish",
                "publish-regenerate": "Regenerate Publish",
                "publish-export": "Export Publish",
                "publish-start-voting": "Start Voting",
                "publish-pause-voting": "Pause Voting",
                "publish-stop-voting": "Stop Voting",
                "publish-changes": "Publish Changes",
                "election-event-publish-view": "Election Event Publish View",
                "election-event-keys-columns": "Election Event Keys Columns",
                "create-ceremony": "Create Ceremony",
                "export-ceremony": "Export Ceremony",
                "election-event-tally-columns": "Election Event Tally Columns",
                "election-event-tally-back-button": "Back to Election Event Tally",
                "transmition-ceremony": "Transmission Ceremony",
                "admin-ip-address-view": "View IP Address",
                "election-approvals-tab": "View Election Approvals",
                "election-event-approvals-tab": "View Election Event Approvals",
                "election-ip-address-view": "View Election IP Address",
                "election-dashboard-tab": "View Election Dashboard",
                "trustees-export": "Export Trustees",
                "user-import": "Import Users",
                "voter-voted-edit": "Edit voters who voted",
                "voter-email-tlf-edit": "Edit voters email/phone fields",
                "cloudflare-write": "Edit Country Blocking Rules in Cloudflare",
                "transmission-report-generate": "Generate Transmission Report",
                "google-meet-link": "Generate google meet link",
                "service-account": "Service account",
                "datafix-account": "Datafix account",
                "gold": "Gold",
                "silver": "Silver",
                "election-event-ivr-tab": "View election event IVR",
                "election-event-cas-tab": "View election event CAS",
                "ca-read": "Read certificate authorities",
                "ca-write": "Edit certificate authorities",
                "generate-preview": "Generate preview",
                "preview-read": "Read preview",
                "tally-resolution-submit": "Submit tally resolution",
                "phone-blacklist-read": "Read phone blacklist",
                "phone-blacklist-create": "Create phone blacklist entries",
                "phone-blacklist-update": "Edit phone blacklist entries",
                "phone-blacklist-delete": "Delete phone blacklist entries",
                "election-event-voter-list-reconciliation": "Reconcile election event voter list",
            },
        },
        generalSettingsScreen: {
            body: "Enable languages in the system. Only languages enabled here will be available for election events.",
        },
        eventsScreen: {
            title: "Scheduled Events",
            subtitle: "Manages the configuration of the automatic execution of events like the start or end of the voting period.",
            messages: {
                createSuccess: "Scheduled Event created successfully",
                createError: "Error creating Scheduled Event",
                editSuccess: "Scheduled Event edited successfully",
                editError: "Error editing Scheduled Event",
            },
            eventType: {
                label: "Type",
                ALLOW_INIT_REPORT: "Allow Initialization Report",
                START_VOTING_PERIOD: "Start Voting Period",
                END_VOTING_PERIOD: "End Voting Period",
                ALLOW_VOTING_PERIOD_END: "Allow Voting Period End",
                START_ENROLLMENT_PERIOD: "Start Enrollment Period",
                END_ENROLLMENT_PERIOD: "End Enrollment Period",
                START_LOCKDOWN_PERIOD: "Start Lockdown Period",
                END_LOCKDOWN_PERIOD: "End Lockdown Period",
                ALLOW_TALLY: "Allow Tally",
            },
            election: {
                label: "Election",
            },
            empty: {
                header: "No Scheduled Events yet.",
                body: "Do you want to create one?",
                button: "Create Scheduled Event",
            },
            create: {
                title: "Create Scheduled Event",
                subtitle: "Create a new Scheduled Event configuration.",
            },
            edit: {
                title: "Edit Scheduled Event",
                subtitle: "Edit Scheduled Event configuration.",
                delete: "Are you sure you want delete this Scheduled Event?",
            },
            fields: {
                electionId: "Election",
                eventProcessor: "Type",
                stoppedAt: "Stopped At",
                scheduledDate: "Scheduled At",
            },
        },
        reportsScreen: {
            title: "Reports",
            subtitle: "Generate reports for the election events",
            messages: {
                createSuccess: "Report created successfully",
                createError: "Error creating Report",
                submitError: "Error submitting Report",
                updateSuccess: "Report updated successfully",
                passwordMismatch: "Password and confirm password do not match. Please ensure both fields contain the same password.",
                incorectPassword: "Incorrect password",
                decryptFileTitle: "How to decrypt the file",
                decryptInstructions: "1. '-in' :The path to the encrypted file. \n2. '-out' :The path where the decrypted file will be saved. \n3. '-pass' :The password used to encrypt the file. \n",
                encryptSuccess: "Successfully set up report encryption",
                encryptError: "Error setting up report encryption",
            },
            reportType: {
                BALLOT_RECEIPT: "Ballot Receipt",
                ELECTORAL_RESULTS: "Electoral Results",
                MANUAL_VERIFICATION: "Manual Verification",
                PARTICIPATION_REPORT: "Participation Report",
                STATISTICAL_REPORT: "Statistical Report",
                OVCS_EVENTS: "Overseas Voting Monitoring - OVCS Events",
                AUDIT_LOGS: "Audit Logs",
                ACTIVITY_LOG: "Activity Log",
                STATUS: "Status",
                OVCS_INFORMATION: "OVCS Information",
                OVERSEAS_VOTERS: "List of overseas voters",
                OV_USERS_WHO_VOTED: "List of Overseas Voters who Voted",
                OV_WITH_VOTING_STATUS: "List of Overseas Voters with Voting Status",
                OVCS_STATISTICS: "Overseas Voting Monitoring - OVCS Statistics",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "List of OV who Pre-enrolled but Disapproved",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "List of OV who Pre-enrolled but subject for Manual Validation",
            },
            reportEncryptionPolicy: {
                title: "Encryption Policy",
                UNENCRYPTED: "Unencrypted",
                CONFIGURED_PASSWORD: "Configured Password",
            },
            empty: {
                header: "No Reports yet.",
                body: "Do you want to create one?",
                button: "Create Report",
            },
            create: {
                title: "Create Report",
                subtitle: "Create a new Report configuration.",
            },
            edit: {
                title: "Edit Report",
                subtitle: "Edit Report configuration.",
                delete: "Are you sure you want delete this Report?",
            },
            fields: {
                electionId: "Election",
                template: "Template",
                reportType: "Report Type",
                repeatable: "Repeatable",
                cronExpression: "Cron Expression",
                emailRecipients: "Email Recipients",
                emailRecipientsPlaceholder: "Type email and press Enter",
            },
            delete: {
                body: "Are you sure you want delete this Report?",
            },
            actions: {
                generate: "Generate",
                delete: "Delete",
                edit: "Edit",
                preview: "Preview",
            },
        },
        googleMeet: {
            title: "Generate Google Meet Link",
            generateButton: "Google Meet",
            meetingTitle: "Meeting Title",
            description: "Description (Optional)",
            startDate: "Start Date",
            startTime: "Start Time",
            duration: "Duration (minutes)",
            attendeeEmails: "Attendee Emails",
            attendeeEmailHelp: "Comma-separated emails for meeting participants",
            note: "Note: This will create a calendar event in your Google Calendar with a Google Meet link. You'll need to sign in to your Google account.",
            success: "Google Meet Link Generated Successfully!",
            copy: "Copy to clipboard",
            copied: "Link copied to clipboard!",
            instructions: "Share this link with participants to join the meeting. The calendar event has been added to your Google Calendar.",
            generating: "Generating...",
            generate: "Generate Meet Link",
        },
        common: {
            export: "Export can be a long operation. Are you sure you want to export records?",
            resources: {
                electionEvent: "Election Event",
                election: "Election",
                contest: "Contest",
                candidate: "Candidate",
                noResult: {
                    askCreate: "Do you want to create one?",
                },
            },
            label: {
                add: "Add",
                actions: "Actions",
                create: "Create",
                delete: "Delete",
                archive: "Archive",
                unarchive: "Unarchive",
                cancel: "Cancel",
                edit: "Edit",
                yes: "Yes",
                no: "No",
                save: "Save",
                close: "Close",
                back: "Back",
                next: "Next",
                warning: "Warning",
                json: "Preview",
                noResult: "No result",
                import: "Import",
                export: "Export",
                loadingData: "Loading data ...",
                exportFormat: "Export in {{format}} format - '{{item}}' results",
                allResults: "election event",
                globalAreaResults: "all areas",
                title: "Title",
                subtitle: "Subtitle",
                kind: "File type",
                filter: "Custom Filters",
                approve: "Approve",
                continue: "Continue",
                logout: "Logout",
                selectTenant: "Select Tenant",
                processing: "Processing...",
                tenantName: "Tenant Name",
            },
            language: {
                es: "Spanish",
                en: "English",
                fr: "French",
                cat: "Valencian",
                tl: "Tagalog",
                gl: "Galician",
                nl: "Dutch",
                eu: "Euskera",
            },
            channel: {
                online: "Online",
                kiosk: "Kiosk",
                early_voting: "Early voting",
                telephone: "Telephone voting",
                other: "Other",
            },
            message: {
                delete: "Are you sure you want to delete this item?",
                continueOrLogout: "Do you want to stay connected to this tenant or logout?",
            },
        },
        createResource: {
            electionEvent: "Create an Election Event",
            election: "Create an Election",
            contest: "Create a Contest",
            candidate: "Create a Candidate",
        },
        importResource: {
            electionEvent: "Import an Election Event",
            election: "Import an Election",
            contest: "Import a Contest",
            candidate: "Import a Candidate",
            ImportHashMismatch: "Hashes don't match. Integrity check failure.",
        },
        sideMenu: {
            electionEvents: "Election Events",
            search: "Search",
            usersAndRoles: "Users and Roles",
            logs: "Logs",
            settings: "Settings",
            help: "Help",
            templates: "Templates",
            active: "Active",
            archived: "Archived",
            addResource: {
                electionEvent: "Create an Election Event",
                election: "Create an Election",
                contest: "Create a Contest",
                candidate: "Create a Candidate",
            },
            menuActions: {
                archive: {
                    electionEvent: "Archive this Election Event",
                },
                unarchive: {
                    electionEvent: "Unarchive this Election Event",
                    election: "Unarchive this election",
                    contest: "Unarchive this Contest",
                    candidate: "Unarchive this Candidate",
                },
                remove: {
                    electionEvent: "Remove this Election Event",
                    election: "Remove this Election",
                    contest: "Remove this Contest",
                    candidate: "Remove this Candidate",
                },
                messages: {
                    confirm: {
                        archive: "Are you sure to archive this item?",
                        unarchive: "Are you sure to unarchive this item?",
                        delete: "Are you sure to delete this item?",
                    },
                    notification: {
                        success: {
                            archive: "The item has been archived",
                            unarchive: "The item has been unarchived",
                            delete: "The item has been deleted",
                            reloading: "Wait. The page will be reloaded in a few moments.",
                        },
                        error: {
                            archive: "Error while trying to archive this item",
                            unarchive: "Error while trying to unarchive this item",
                            delete: "Error while trying to delete this item",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Candidate configuration.",
            },
            edit: {
                externalId: "External ID",
                general: "General",
                type: "Type",
                image: "Image",
                isDisabled: "Disabled",
                isExplicitInvalid: "Invalid Vote",
                isExplicitBlank: "Blank Vote",
                isCategoryList: "Category List",
                isWriteIn: "Write-in",
            },
            field: {
                name: "Name",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "candidate": "Candidate",
                "option": "Option",
                "write-in": "Write-in",
                "open-list": "Open List",
                "closed-list": "Closed List",
                "semi-open-list": "Semi Open List",
                "invalid-vote": "Invalid Vote",
                "blank-vote": "Blank Vote",
            },
            invalidVotePosition: {
                label: "Invalid Vote Position",
                null: "None (Default)",
                top: "Top",
                bottom: "Bottom",
            },
            error: {},
            createCandidateSuccess: "Candidate created",
            createCandidateError: "Error creating candidate",
        },
        contestScreen: {
            common: {
                subtitle: "Contest configuration.",
            },
            edit: {
                externalId: "External ID",
                general: "General",
                type: "Type",
                image: "Image",
                system: "Ballot Voting System",
                design: "Ballot Design",
                reorder: "Reorder candidates",
                policies: "Policies",
            },
            field: {
                name: "Name",
                alias: "Alias",
                description: "Description",
            },
            options: {
                "non-preferential": "No Preferential",
                "plurality-at-large": "Plurality at Large",
                "instant-runoff": "Instant Runoff",
                "random": "Random",
                "external-procedure": "External Procedure",
                "custom": "Custom",
                "alphabetical": "Alphabetical",
            },
            tieBreakingPolicy: {
                label: "Tie-Breaking Policy",
            },
            auditButtonConfig: {
                "label": "Audit Button Display Options",
                "show": "Show",
                "not-show": "Not Show",
                "show-in-help": "Show In Help Dialog",
            },
            underVotePolicy: {
                "label": "Under Vote Policy",
                "allowed": "Allowed",
                "warn-only-in-review": "Warn in Review",
                "warn": "Warn",
                "warn-and-alert": "Warn and Alert",
            },
            invalidVotePolicy: {
                "label": "Invalid Vote Policy",
                "allowed": "Allowed",
                "warn": "Warn",
                "warn-invalid-implicit-and-explicit": "Warn Invalid Implicit And Explicit",
                "not-allowed": "Not Allowed",
                "allowed-with-exclusive-explicit": "Allowed With Exclusive Explicit",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Candidates checkbox icon shape",
                "square-checkbox": "Square Checkbox",
                "round-checkbox": "Round Checkbox",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidates And Lists",
                "allow-selecting-candidates": "Candidates Only",
                "allow-selecting-lists": "Lists Only",
                "disabled": "Disabled",
            },
            collapsibleListsPolicy: {
                "label": "Collapsible Lists",
                "disabled": "Disabled",
                "enabled-expanded": "Enabled (starts expanded)",
                "enabled-collapsed": "Enabled (starts collapsed)",
            },
            blankVotePolicy: {
                "label": "Blank Vote Policy",
                "allowed": "Allowed",
                "warn-only-in-review": "Warn in Review",
                "warn": "Warn",
                "not-allowed": "Not Allowed",
            },
            overVotePolicy: {
                "label": "Over Vote Policy",
                "allowed": "Allowed",
                "allowed-with-msg": "Allowed with Warning Message",
                "allowed-with-msg-and-alert": "Allowed with Warning message and Alert",
                "not-allowed-with-msg-and-alert": "Not Allowed with Warning message and Alert",
                "not-allowed-with-msg-and-disable": "Not Allowed with Warning message and Disable further selections",
            },
            duplicatedRankPolicy: {
                "label": "Invalid Vote - Duplicate Rank Policy",
                "allowed-warn-and-dialog": "Show Warning and Dialog (voter can proceed)",
                "not-allowed-warn-and-dialog": "Show Warning and Dialog (voter not allowed to proceed)",
            },
            preferenceGapsPolicy: {
                "label": "Invalid Vote - Skipped Ranks Policy",
                "allowed-warn-and-dialog": "Show Warning and Dialog (voter can proceed)",
                "not-allowed-warn-and-dialog": "Show Warning and Dialog (voter not allowed to proceed)",
            },
            paginationPolicy: {
                label: "Page Name",
            },
            isAcclaimed: {
                label: "Decided by acclamation",
                helperText: "Voters see this contest but cannot select anything, nothing is recorded for it, and every candidate is reported as a winner with zero votes. Set this before publishing ballots: changing it afterwards invalidates ballots already cast.",
            },
            allowWriteins: {
                label: "Allow Write-Ins",
            },
            maxVotes: {
                helperText: "Maximum number of candidates a voter can select (non-preferential voting).",
                helperTextPreferential: "Highest ranking position available to voters (e.g. '5' means positions 1–5). Must be at least the number of candidates to rank (preferential voting).",
            },
            error: {},
            createContestSuccess: "Contest created",
            createContestError: "Error creating candidate",
        },
        keysGeneration: {
            configureStep: {
                create: "Create Keys Ceremony",
                name: "Keys Ceremony Name",
                allElections: "All Elections",
                title: "Create Election Event Keys Ceremony",
                subtitle: "In the Keys Ceremony each trustee will generate and download their fragment of the private key for the Election Event. To proceed, please choose the trustees that will participate in the ceremony and the threshold, which is the minimum number of trustees required to tally.",
                threshold: "Threshold",
                trusteeList: "Trustees",
                errorMinTrustees_one: "You selected only {{selected}} trustee, but you must select at least {{threshold}}.",
                errorMinTrustees_other: "You selected only {{selected}} trustees, but you must select at least {{threshold}}.",
                errorThreshold: "You selected threshold {{selected}} but it must be between {{min}} and {{max}}.",
                errorCreatingCeremony: "Error creating Keys Ceremony: {{error}}",
                createCeremonySuccess: "Keys Ceremony created",
                confirmdDialog: {
                    ok: "Yes, Create Keys Ceremony",
                    cancel: "Cancel",
                    title: "Are you sure you want to Create Keys Ceremony?",
                    automaticCeremonyTitle: "Are you sure you want to Create Automatic Keys Ceremony?",
                    description: "You are about to Create Keys Ceremony. This action will notify the Trustees to participate in the creation and distribution of the Election Event Keys.",
                    automaticCeremonyDescription: "You are about to Create an Automatic Keys Ceremony. This will not notify the Trustees to participate.",
                },
                filterTrustees: "Filter Trustees",
                errorPermisionLabels: "Cannot create keys ceremony: one or more permission labels are missing.",
                automaticCeremonyToggle: "Automatic Ceremony",
            },
            ceremonyStep: {
                cancel: "Cancel Keys Ceremony",
                progressHeader: "Keys Ceremony Progress",
                description: "This screen shows the progress and logs of the Election Event's Keys Ceremony. In the Keys Ceremony each trustee will generate and download their fragment of the private key for the Election Event.",
                executionStatus: "Status: {{status}}",
                confirmdDialog: {
                    ok: "Yes, Cancel Create Keys Ceremony",
                    cancel: "Go back to Keys Ceremony",
                    title: "Are you sure you want to Cancel Keys Ceremony?",
                    description: "You are about to Cancel Keys Ceremony. After performing this action, to have a succcessful Keys Ceremony you will have to Create a new one.",
                },
                header: {
                    trusteeName: "Trustee Name",
                    fragment: "Key Fragment Generated",
                    downloaded: "Private Key Fragment Downloaded",
                    checked: "Private Key Fragment Checked",
                },
                logsHeader: {
                    title: "Logs",
                    date: "Date",
                    entry: "Entry",
                },
                emptyLogs: "No logs yet.",
            },
            startStep: {
                title: "Trustee Keys Ceremony",
                subtitle: "You are about to participate in the Keys Ceremony as a Trustee (<strong>{{name}}</strong>). This involves the following steps:",
                one: "<strong>Download</strong> your Encrypted Private Key.",
                two: "Create multiple <strong>Backups</strong> of the Encrypted Private Key.",
                three: "<strong>Check</strong> that the backups works well.",
            },
            downloadStep: {
                title: "Download Encrypted Private Key",
                subtitle: "To continue, please download and store your Encrypted Private Key at least into two different devices:",
                downloadButton: "Download your Encrypted Private Key",
                downloaded: "Encrypted Private Key downloaded successfully.",
                errorEmptyKey: "Download error, empty file",
                unexpectedError: "The private key could not be downloaded. Please try again.",
                alreadyVerified: "Your private key was already downloaded and verified.",
                unavailable: "Private key download is no longer available because the ceremony has moved on.",
                confirmdDialog: {
                    ok: "Confirm Backups and Continue",
                    cancel: "Go Back",
                    title: "Backup your Encrypted Private Key",
                    description: "Please backup your Encrypted Private Key in at least two different secure locations and then confirm it below:",
                    firstCopy: "First backup secured",
                    secondCopy: "Second backup secured",
                    confirmError: "Create required backups and check the confirmation boxes to continue",
                },
            },
            checkStep: {
                title: "Check your Encrypted Private Key Backups",
                verifyButton: "Verify key",
                subtitle: "Upload a Encrypted Private Key Backup to check that it's correct. You can try as many times as needed, from your different backups:",
                errorUploading: "Invalid Encrypted Private Key Backup, please try again",
                errorEmptyFile: "File empty or not found",
                verified: "Backup verified successfully.",
                alreadyRestored: "Your key was already restored.",
            },
        },
        miruExport: {
            create: {
                success: "Creating Transmission Package...",
                error: "Error creating Transmission Package ",
            },
            send: {
                success: "Sending Transmission Package...",
                error: "Error sending Transmission Package ",
            },
        },
        tally: {
            errorUploadingSignature: "There was an error uploading signature",
            downloadTransmissionPackage: "Download Transmission Package",
            resultsPublication: {
                sectionTitle: "Publish to results website",
                policyTitle: "Results Website",
                policyAccess: "Results Website Access",
                policyVisibility: "Results Website Visibility",
                enabled: "Enabled",
                disabled: "Disabled",
                fullEvent: "Full event",
                areaBased: "Area based",
                publishStarted: "Results publication started",
                publishError: "Could not start results publication",
                revoked: "Results publication revoked",
                revokeError: "Could not revoke results publication",
                waitingForTally: "Results can be published after this tally has completed.",
                writePermissionRequired: "You need publish-results-write permission to publish or revoke results.",
                readPermissionRequired: "You need publish-results-read permission to view publication history.",
                disabledPolicy: "Results website publishing is disabled for this election event. Enable it in the election event data before publishing results.",
                loadingElectionContext: "Results publication is loading election context.",
                route: "Route",
                eventResults: "Event results",
                electionResults: "Election results",
                election: "Election",
                access: "Access",
                publicAccess: "Public access",
                authenticatedAccess: "Authenticated access",
                visibility: "Visibility",
                fullPublishedScope: "Full published scope",
                personalVisibility: "Personal visibility",
                contests: "Contests",
                noTalliedContests: "No tallied contests available.",
                publishSelectedContests: "Publish selected contests",
                selectedContestCount: "{{count}} contest selected",
                selectedContestCount_plural: "{{count}} contests selected",
                history: "Publication history",
                version: "Version",
                status: "Status",
                published: "Published",
                revokedAt: "Revoked",
                actions: "Actions",
                open: "Open",
                revoke: "Revoke",
                noPublications: "No publications yet.",
                confirmTitle: "Start publish to results website?",
                confirmDescription: "This will create a new publication from the current tally execution. The existing voter-facing results stay active until this publish task succeeds.",
                close: "Close",
            },
            transmissionPackage: {
                title: "Transmission Package for Area '{{name}}' and Election '{{eventName}}'",
                description: "Allows you to export a Transmission Package to Destination Servers or download it.",
                actions: {
                    send: {
                        title: "Send",
                        dialog: {
                            title: "Do you want to Send the Transmission Package?",
                            description: "Please confirm you want to Send the Transmission Package for Area `{{name}}` to the Destination Servers.",
                            confirm: "Send Transmission Package",
                            cancel: "Close",
                        },
                    },
                    regenerate: {
                        title: "Regenerate",
                        dialog: {
                            title: "Do you want to regenerate the Transmission Package?",
                            description: "Please confirm you want to regenerate the Transmission Package for Area `{{name}}`",
                            confirm: "Regenerate Transmission Package",
                            cancel: "Close",
                        },
                    },
                    sign: {
                        title: "Regenerate",
                        dialog: {
                            title: "Do you want to sign the Transmission Package?",
                            description: "Please confirm you want to regenerate the Transmission Package for Area `{{name}}`",
                            confirm: "Sign Transmission Package",
                            cancel: "Close",
                            input: {
                                placeholder: "Enter your password",
                            },
                        },
                    },
                    download: {
                        title: "Download",
                        emlTitle: "Download EML {{date}}",
                        transmissionPackageTitle: "Download Transmission Package {{date}}",
                        transmissionReportTitle: "Download Transmission Report",
                        dialog: {
                            title: "Do you want to Download the Transmission Package?",
                            description: "Please confirm you want to Download the Transmission Package for Area `{{name}}.`",
                            confirm: "Download Transmission Package",
                            cancel: "Close",
                        },
                    },
                },
                destinationServers: {
                    title: "Destination Servers",
                    description: "The table below shows the sending status of each of the Destination Servers.",
                    status: "Sent to {{signed}} out of {{total}}",
                    table: {
                        serverName: "Server Name",
                        sendStatus: "Sending Status",
                    },
                },
                signatures: {
                    title: "SBEI Signatures",
                    description: "SBEIs can sign the Transmission Package. The table below shows the signing status of each of the SBEI members.",
                    status: "{{signed}} out of {{total}} Signed, {{minimum}} minimum",
                    table: {
                        trusteeName: "SBEI id",
                        signed: "Has Signed",
                    },
                },
            },
            sendToTransmissionPackageServers: "Send Transmission Package for Area '{{name}}'",
            uploadTransmissionPackage: "Sign Transmission Package",
            uploadTransmissionPackageDesc: "Upload your Signature to sign the Transmission Package. This is an optional operation.",
            exportElectionArea: "Generate Transmission Package for Area '{{name}}'",
            generateReport: "Generate {{name}}",
            templateTitle: "Results Template",
            templateSubTitle: "Optionally overwrite the results template.",
            keysCeremonyTitle: "Keys Ceremony",
            keysCeremonySubTitle: "Select the Keys Ceremony for this tally",
            ceremonyTitle: "Elections to Tally",
            initializationTitle: "Elections for Initialization Report",
            ceremonySubTitle: "Choose the elections you want to tally",
            tallyTitle: "Elections Tally Progress",
            logsTitle: "Logs",
            resultsTitle: "Results & Participation",
            generalInfoTitle: "General Information",
            trusteeTallyTitle: "Trustees",
            trusteeTallySubTitle: "Key fragment import status",
            createTallySuccess: "Tally created",
            createTallyError: "Could not create Tally",
            startTallySuccess: "Tally started",
            startTallyError: "Could not start Tally",
            startTallyCeremonySuccess: "Tally Ceremony started",
            startTallyCeremonyError: "Could not start Tally Ceremony",
            cancelTallyCeremonySuccess: "Tally Ceremony canceled",
            cancelTallyCeremonyError: "Could not cancel Tally Ceremony",
            recountTallyCeremony: "Recount tally",
            recountTallyCeremonyMessage: "This will generate a fresh results event for the completed tally session.",
            recountTallyCeremonyStarting: "Starting recount...",
            recountTallyCeremonySuccess: "Recount started",
            recountTallyCeremonyError: "Could not start recount",
            recountTallyCeremonyOk: "Recount",
            trusteeTitle: "Trustees process",
            trusteeSubTitle: "Please upload you key fragment",
            invited: "You have been invited to participate in a Tally ceremony. Please ",
            click: "click on the tally Action",
            participate: "to participate.",
            breadcrumbSteps: {
                start: "Start",
                finish: "Finish",
                tally: "Tally",
                results: "Results",
                ceremony: "Ceremony",
            },
            common: {
                title: "Tally",
                subTitle: "Tally configuration.",
                cancel: "Back",
                next: "Next",
                date: "Tally Date",
                global: "Global",
                noTrustees: "No trustees yet",
                imported: " trustees imported the key",
                needed: " trustees needed",
                start: "Start Tally",
                ceremony: "Start Tally Ceremony",
                initialization: "Start Initialization Report",
                results: "Results",
                dialog: {
                    ok: "Ok",
                    okTally: "Start Tally",
                    okCancel: "Cancel Tally",
                    cancel: "Close",
                    title: "Are you sure you want to  start a ceremony?",
                    tallyTitle: "Are you sure you want to  start the tally?",
                    cancelTitle: "Are you sure you want to  cancel the tally?",
                    message: "You are about to start a tally ceremony . This action will notify the trustees to import their key fragments.",
                    cancelMessage: "You are about to cancel the tally ceremony. This action is not undoable.",
                    ceremony: "All required trustees have verified their key fragments. Everything is ready to begin receiving results. Do you want to start the Tally?",
                    startAutomatedTallyMessage: "Select Start Tally to run tally process and display results, or Close to cancel.",
                },
            },
            table: {
                elections: "Elections",
                selected: "Selected",
                status: "Status",
                progress: "Progress",
                method: "Tally Method",
                elegible: "Eligible Voters",
                number: "Number of Votes",
                total: "Total",
                turnout: "%",
                candidates: "Candidate Results",
                options: "Options",
                global: "Participation Summary",
                elegible_census: "Eligible Voters",
                cast_votes: "Number of Votes",
                cast_votes_percent: "Percent of Votes",
                total_votes: "Total Voters",
                total_votes_percent: "Participation",
                total_votes_counted: "Total Votes Counted",
                total_auditable_votes: "Total Auditable Votes",
                total_valid_votes: "Total Valid Votes",
                total_valid_votes_percent: "Valid Votes Percent",
                total_invalid_votes: "Total Invalid Votes",
                total_invalid_votes_percent: "Invalid Votes Percent",
                explicit_invalid_votes: "Explicitly Invalid Votes",
                explicit_invalid_votes_percent: "Explicitly Invalid Votes Percent",
                implicit_invalid_votes: "Implicitly Invalid Votes",
                implicit_invalid_votes_percent: "Implicitly Invalid Votes Percent",
                blank_votes: "Blank Votes",
                explicit_blank_votes: "Explicit Blank Votes",
                implicit_blank_votes: "Implicit Blank Votes",
                blank_votes_percent: "Blank Votes Percent",
                number_of_votes: "Number of Votes",
                winning_position: "Winning position",
                weight: "Weight",
                preferential: {
                    candidate: "Candidate",
                    winner: "Winner",
                    eliminated: "Eliminated",
                    round: "Round",
                },
                total_declined_to_vote: "Total Declined to Vote",
                total_blank_ballots: "Total Blank Ballots",
                participation_by_channel: "Participation by channel",
                channel: "Channel",
                channel_online: "Online",
                channel_kiosk: "Kiosk",
                channel_early_voting: "Early voting",
                channel_telephone: "Telephone",
                channel_paper: "Paper",
                channel_postal: "Postal",
                channel_in_person: "In person",
                acclamation_note: "Won by acclamation. This contest was decided without a vote, so no votes were recorded for it.",
            },
            pendingResolutions: {
                round: "Round {{round}}",
                tieResolutionRequired: "Tie Resolution Required",
                tieResolved: "Tie Resolved",
                globalArea: "Global",
                pendingResolutionsHeader: "Pending resolutions",
                pendingResolutionStatus: "Pending Resolution",
                resolvedStatus: "Resolved",
                resolutionTitle: "Resolution",
                selectContest: "Select an item from the left to view details",
                selectCandidateToAdvance: "Select candidate to advance",
                undoResolution: "Undo Resolution",
                applyResolutions: "Apply Resolutions and Recalculate",
                submitSuccess: "Resolutions submitted. Tally is resuming...",
                submitError: "Failed to submit resolutions. Please try again.",
                filter: "Filter",
                save: "Save",
                pendingApplyStatus: "Pending calculation",
                filterElection: "Election",
                filterContest: "Contest",
                filterArea: "Area",
                filterStatusLabel: "Status",
                clearFilters: "Clear filters",
                candidateWithVotes: "{{name}} ({{votes}} votes)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} votes, {{percent}}%)",
                tieInfoTitle: "Tally paused due to unresolved tie (Round {{round}})",
                tieInfoBody: "Candidates tied ({{votes}} votes, {{percent}}%): {{candidates}}. Manual tie-break required to continue tally.",
                tallyResumedTitle: "Tally resumed after resolution applied",
                tallyResumedBody: "Candidates tie was resolved on {{date}} by {{user}}",
            },
            chart: {
                votesForCandidates: "Votes For Candidates",
                blankVotes: "Blank Votes",
                invalidVotes: "Invalid Votes",
                totalVoters: "Total Voters",
                nonVoters: "Non Voters",
            },
            exportAllAreas: "Export All Areas Results in {{format}} format for '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Select Area for Preview",
                action: "Preview",
                copy: "Copy link",
                copy_success: "Success copying preview link",
                copy_error: "Failed to copy preview link",
                success: "Success opening preview",
            },
            header: {
                change: "Changes to be Published",
                viewChange: "View Publication",
                history: "Publish History",
            },
            action: {
                generateInitializationReport: "Generate Initialization Report",
                startVotingPeriod: "Start Voting",
                startKioskVoting: "Start Kiosk Voting",
                startOnlineVoting: "Start Online Voting",
                startEarlyVoting: "Start Early Voting",
                startTelephoneVoting: "Start Telephone Voting",
                stopVotingPeriod: "Stop Voting",
                stopOnlineVoting: "Stop Online Voting",
                stopEarlyVoting: "Stop Early Voting",
                stopTelephoneVoting: "Stop Telephone Voting",
                stopKioskVotingPeriod: "Stop Kiosk Voting",
                pauseVotingPeriod: "Pause Voting",
                pauseKioskVoting: "Pause Kiosk Voting",
                pauseOnlineVoting: "Pause Online Voting",
                pauseEarlyVoting: "Pause Early Voting",
                pauseTelephoneVoting: "Pause Telephone Voting",
                generate: "Regenerate",
                publish: "Publish Changes",
                back: "Back",
            },
            label: {
                current: "Current",
                previous: "Previous Publication",
                publication: "Publication",
                diff: "Changes to Publish",
            },
            empty: {
                header: "No Publication Yet.",
                action: "Generate Publication",
            },
            forbidden: {
                header: "Cannot Publish until the Keys Ceremony is completed.",
            },
            dialog: {
                title: "Confirm Action",
                info: "You have clicked on a sensitive action, so we need you to confirm in order to continue",
                initializationInfo: "You are about to generate initialization report. Are you sure you want to continue?",
                startInfo: "You are about to start voting period. Are you sure you want to continue?",
                stopInfo: "You are about to stop voting period. Are you sure you want to continue?",
                kioskStopInfo: "You are about to stop the kiosk voting period. Are you sure you want to continue?",
                pauseInfo: "You are about to pause voting period. Are you sure you want to continue?",
                publishInfo: "You are about to generate a publication. Are you sure you want to continue?",
                ok: "Confirm",
                ko: "Cancel",
                error: "Error loading ballot publication",
                error_publish: "Error publishing ballot publication",
                error_capacity: "Ballot style generation failed: {{message}}",
                error_status: "Error change ballot publication status",
                error_preview: "Error previewing publication",
                diff: "Rendering all changes might make the page unresponsive. Are you sure you want to continue?",
                confirmation: "The action you are about to perform is sensitive and requires confirmation. Please enter your password to proceed with {{action}}.",
            },
            notifications: {
                generated: "Ballot generated",
                published: "Ballot published",
                change_status: "Election status changed",
            },
        },
        emailEditor: {
            subject: "Email Subject",
            tabs: {
                plaintext: "Plain Text Body",
                richtext: "Rich Text Body",
            },
        },
        sendCommunication: {
            send: "Send",
            title: "Send Notification",
            subtitle: "Send a notification to voters.",
            sendButton: "Send Notification",
            voters: "Audience",
            schedule: "Schedule",
            nowInput: "Send now",
            dateInput: "Date and time to start sending notifications",
            chooseDate: "Please choose a date",
            languages: "Languages",
            smsMessage: "SMS Message",
            errorSending: "Error sending the notification: {{error}}",
            successSending: "Notification programmed/sent successfully",
            method: "Template Method",
            type: "Communication Type",
            alias: "Template Alias",
            votersSelection: {
                ALL_USERS: "Everyone",
                NOT_VOTED: "Those who didn't vote yet",
                VOTED: "Those who already voted",
                SELECTED: "To {{total}} Selected {{voters}}",
            },
            path: {
                users: "users",
                voters: "voters",
            },
            methodTitle: "Communication Template",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Credentials",
                BALLOT_RECEIPT: "Ballot Receipt",
            },
            email: {
                subject: "Subject",
            },
        },
        tallysheet: {
            title: "Ballot boxes",
            subtitle: "Digitalized ballot boxes by channel",
            createTallySuccess: "Tally Sheet saved",
            createTallyError: "Error saving Tally Sheet",
            createTallyErrorSameKindExists: "Tally Sheet already exists for this contest with the same channel and area",
            allFieldsRequired: "All fields are required",
            header: {
                change: "Changes to be Published",
                viewChange: "View Publication",
                history: "Publish History",
            },
            action: {
                start: "Start Election",
                stop: "Stop Election",
                pause: "Pause",
                generate: "Regenerate",
                publish: "Publish Changes",
                back: "Back",
            },
            inputError: {
                totalValidDoesNotMatch: "Candidate votes ({{candidateVotesSum}}) must be between {{lowerBound}} and {{upperBound}} for this contest's voting rules ({{nonBlankValidVotes}} valid non-blank votes × up to {{maxMarks}} marks per ballot)",
                censusTooSmall: "Total votes ({{totalVotes}}) must not be greater than census ({{census}})",
                totalInvalidDoesNotMatch: "Total invalid votes ({{totalInvalid}}) must equal implicit invalid votes ({{implicitInvalid}}) plus explicit invalid votes ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "Total votes ({{totalVotes}}) must equal total valid votes ({{totalValidVotes}}) plus total invalid votes ({{totalInvalid}})",
                unknownCountingAlgorithm: "This contest's counting algorithm ({{countingAlgorithm}}) is not recognised, so the allowed number of candidate votes cannot be determined. Check the contest configuration.",
                blankBallotsInconsistent: "Blank Ballots must have the same value on every contest sheet of this ballot box",
                blankBallotsOutOfBounds: "Blank Ballots value is outside the range implied by this box's per-contest blank vote counts",
            },
            label: {
                area: "Area",
                channel: "Channel",
                total_votes: "Total Votes",
                total_valid_votes: "Total Valid Votes",
                total_invalid: "Total Invalid Votes",
                explicit_invalid: "Explicitly Invalid Votes",
                implicit_invalid: "Implicitly Invalid Votes",
                total_blank_votes: "Blank Votes",
                blank_ballots: "Blank Ballots",
                census: "Census",
            },
            common: {
                tallyCeremony: {
                    manage: "Manage Tally Ceremony",
                    view: "View Tally Ceremony",
                    cancel: "Cancel Tally Ceremony",
                    addKey: "Add Tally Key",
                },
                edit: "Edit",
                confirm: "Confirm",
                back: "Back",
                next: "Next",
                cancel: "Back",
                data: "Data",
                title: "Tally Sheet",
                subtitle: "Tally Sheet configuration.",
                candidates: "Candidates",
                save: "Save",
                approve: "Approve",
                disapprove: "Disapprove",
                show: "Show",
                add: "Add",
                versions: "Versions",
                warningDisapprove: "Are you sure to disapprove this Tally Sheet?",
                warningApprove: "Are you sure to approve this Tally Sheet?",
            },
            empty: {
                header: "No Tally Sheet Yet.",
                action: "Generate Tally Sheet",
                add: "Add",
            },
            breadcrumbSteps: {
                start: "Start",
                edit: "Edit",
                confirm: "Confirm",
                view: "View",
            },
            table: {
                area: "Area",
                contest: "Contest",
                approvedVersion: "Approved version",
                latestVersion: "Latest version",
                labels: "Labels",
                annotations: "Annotations",
            },
            versionsTable: {
                title: "Versions for ballot box",
                version: "Version",
                createdBy: "Created by",
                reviewedBy: "Reviewed by",
                createdAt: "Created at",
                reviewedAt: "Reviewed at",
                sourceImport: "Source import",
                importStatus: "Import status",
                openImport: "Open import",
                sourceFile: "Source file",
            },
            message: {
                reviewError: "Error reviewing tally sheet",
                reviewSuccess: "Tally sheet reviewed",
            },
        },
        application: {
            import: {
                title: "Import applications",
                subtitle: "Import applications data",
                paragraph: "Import applications using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
                messages: {
                    success: "Applications imported successfully",
                    error: "Error importing applications",
                },
            },
            export: {
                title: "Export applications",
                subtitle: "Export applications data",
                button: "Export",
                paragraph: "Export applications data to a spreadsheet file in Comma Separated Values (CSV) format.",
                messages: {
                    success: "Applications exported successfully",
                    error: "Error exporting applications",
                },
            },
        },
        template: {
            noPermissions: "You don't have permission to access templates.",
            title: "Templates",
            subtitle: "List of templates",
            chooseMethods: "Choose Methods",
            default: "Use default template",
            empty: {
                title: "No Template Yet",
                subtitle: "Do you want to create one?",
            },
            action: {
                createOne: "Create Template",
            },
            create: {
                title: "Create a Template",
                success: "Template created",
                error: "Error creating Template",
            },
            update: {
                success: "Template updated",
                error: "Error updating Template",
            },
            edit: {
                title: "Edit a Template",
            },
            form: {
                smsMessage: "SMS Message",
                document: "Document",
                pdfOptions: "PDF Options",
                reportOptions: "Report Options",
                name: "Template Name",
                alias: "Template Alias",
                type: "Type",
                communicationMethod: "Method",
            },
            type: {
                CREDENTIALS: "Credentials",
                INITIALIZATION_REPORT: "Initialization Report",
                ELECTORAL_RESULTS: "Electoral Results",
                BALLOT_IMAGES: "Ballot Images",
                BALLOT_RECEIPT: "Ballot Receipt",
                ACTIVITY_LOGS: "Activity Logs",
                MANUAL_VERIFICATION: "Manual Verification",
                PARTICIPATION_REPORT: "Participation Report",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Document",
            },
            import: {
                title: "Import Templates",
                subtitle: "Import templates data",
                paragraph: "Import templates using a spreadsheet file in Comma Separated Values (CSV) format. Download an example import CSV file here.",
            },
        },
        materials: {
            createMaterialSuccess: "Support material created",
            createMaterialError: "Error creating support material",
            updateMaterialSuccess: "Support material updated",
            updateMaterialError: "Error updating support material",
            common: {
                title: "Support Material",
                subtitle: "Enter support material data.",
            },
            error: {
                title: "Title is required",
                document: "Document is required",
            },
            fields: {
                isHidden: "Is Hidden",
                publicUrl: "Public URL",
            },
            empty: {
                header: "No support material yet",
                action: "Generate support material  ",
            },
        },
        widget: {
            logs: "Logs",
        },
        settings: {
            countries: {
                title: "Country Blocking",
                votingDescription: "Choose below the countries you want to block voting from.",
                enrollmentDescription: "Choose below the countries you want to block enrollment from.",
                error: {
                    errorSaving: "Error saving the country list",
                },
            },
            backupRestore: {
                title: "Backup / Restore Tenant config",
                backup: {
                    label: "Backup",
                    subtitle: "Backup Tenant configurations",
                },
                restore: {
                    label: "Restore",
                    subtitle: "Restore Tenant config",
                    title: "Import Tenant Configurations",
                    paragraph: "Import tenant configurations, Keycloak configurations, roles & permissions data using zip folder",
                    tenantConfigOption: "Import Tenant Configurations",
                    keycloakConfigOption: "Import Keycloak Configurations",
                    RolesConfigOption: "Import Roles & Permissions Configurations",
                },
            },
            previewScreen: {
                label: "Previews",
                noContent: "No Previews found",
                table: {
                    title: "External Previews",
                    description: "A record of ballot style previews generated via external requests",
                    requestedBy: "Requested By",
                    document: "Document",
                    url: "URL",
                },
            },
            languages: {
                default: "Default Language",
            },
        },
        approvalsScreen: {
            column: {
                status: "Status",
                id: "ID",
                applicantId: "Applicant ID",
                verificationType: "Verification Type",
                createdAt: "Created At",
                updatedAt: "Updated At",
                verified_by: "Verified By",
            },
            approvalRequest: "Approval Request",
            title: "Voters",
            subtitle: "Find matching voters",
            approve: {
                body: "Are you sure you want to approve this voter? This action is not reversible.",
            },
            reject: {
                label: "Reject Application",
                confirm: "Are you sure you want to reject this voter? This action is not reversible.",
                rejectReason: "Rejection Reason",
                message: "Write here the disapproval reason",
                messageRequired: "A rejection message is required for the 'Other' option.",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Missing Data",
                    "no-matching-voter": "No Matching Voter",
                    "voter-already-approved": "Already Approved",
                    "other": "Other",
                },
            },
            notifications: {
                approveError: "Error approving voter",
                approveSuccess: "Voter approved",
                rejectError: "Error rejecting voter",
                rejectSuccess: "Voter rejected",
                VoterApprovedAlready: "Voter is already approved.",
            },
            export: {
                success: "Applications export finished successfully",
                error: "Error exporting applications",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Voters",
                enrolledOverseasVoters: "Enrolled Overseas Voters",
                approvalStatus: "Approval Status: Approved/Disapproved Voters",
                manuallyApproval: "Manually Approved/Disapproved Voters",
                automaticallyApproval: "Automatically Approved/Disapproved Voters",
                authenticatedVoters: "Authenticated Voters",
                invalidUserErrors: "Invalid User Errors:",
                invalidPasswordErrors: "Invalid Password Errors:",
            },
            polls: {
                title: "Polls",
                initializedSystems: "Posts with Initialized Systems",
                votingOpened: "Posts with Online Voting Opened",
                votingClosed: "Posts with Both Voting Channels Closed",
                votingStarted: "Posts with Voting Started",
                voterTurnout: "Voter Turnout",
            },
            tally: {
                title: "Tally",
                activeVotesCounting: "Posts with Active Vote Counting",
                generatedERs: "Posts with Generated ERs",
                transmittedResults: "Posts with Transmitted Results",
            },
            testing: {
                title: "Testing",
                testElectionVoterCount: "Test Election Voter Count",
            },
        },
        certificateAuthorities: {
            title: "Certificates",
            subtitle: "Certificate Authorities (CAs) trusted for this election event. Imported CAs are used to validate voter certificates.",
            importButton: "Import Certificates",
            type: {
                root: "Root",
                intermediate: "Intermediate",
            },
            expiry: {
                expired: "Expired",
                expiringSoon: "Expiring soon",
                valid: "Valid",
            },
            columns: {
                commonName: "Common Name",
                type: "Type",
                issuerCn: "Issuer CN",
                notBefore: "Valid From",
                notAfter: "Expires",
                fingerprint: "SHA256 Fingerprint",
            },
            importDialog: {
                title: "Import Certificate Authorities",
                subtitle: "Import one or more CA certificates from a PEM file",
                description: "Select a PEM file containing one or more certificates. Bundles are supported — each certificate is imported individually.",
                selectFile: "Select PEM file",
                fileLoaded: "File loaded ({{bytes}} bytes)",
                importButton: "Import",
            },
            notify: {
                importSuccess: "Imported {{inserted}} certificate(s).",
                importSkipped: "{{count}} certificate(s) skipped (already present).",
                importErrors: "Import issues: {{errors}}",
                importError: "Import failed: {{error}}",
                deleteSuccess: "Certificate deleted.",
                deleteError: "Error deleting certificate.",
                exportSuccess: "Certificate(s) exported successfully.",
                exportError: "Error exporting certificates.",
            },
            exportDialog: {
                title: "Export Certificate Authorities",
                description: "You are about to export {{amount}} certificate(s).",
                all: "all",
            },
            deleteDialog: {
                description: "Are you sure you want to delete {{count}} certificate(s)?",
            },
            emptyHeader: "No certificate authorities have been imported for this election event.",
            fileReadError: "Failed to read the file.",
            viewDialog: {
                title: "Certificate Authority Details",
                subject: "Subject",
                issuer: "Issuer",
                serialNumber: "Serial Number",
                pemContent: "PEM Content",
            },
            confirmDelete: "Delete Certificate Authority",
            confirmDeleteDescription: 'Are you sure you want to delete the certificate "{{name}}" (fingerprint: {{fingerprint}})?',
        },
    },
};
export default englishTranslation;
